import React, { createContext, useMemo, useCallback, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { ApiClient } from './ApiClient';

const AppContext = createContext(null);

export const AppContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [user, setUser] = useState(undefined);

  const notify = (message, type = 'info') => {
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'warning':
        toast.warn(message);
        break;
      default:
        toast.info(message);
    }
  };

  const loadState = useCallback(async () => {
    const state = apiClient.getState();
    setIsAuthorized(state !== undefined);
    setUser(state?.user);
  });

  const apiClient = new ApiClient(window.env.REACT_APP_API_URL, setIsLoading, notify);

  
  useMemo(() => {
    loadState();
  }, []);

  return (
    <AppContext.Provider value={{
      apiClient,
      isAuthorized,
      setIsAuthorized,
      user,
      setUser,
      isLoading,
      setIsLoading,
      notify
    }}>
      {children}
      <ToastContainer position="bottom-right" autoClose={3000} />
    </AppContext.Provider>
  );
};

export { AppContext };
